const setReadmore = () => {
  const tableDom = document.getElementById("products-comparison-chart-content");
  const readMore = document.getElementById(
    "products-comparison-chart-readmore"
  );

  if (!readMore || !tableDom) return;

  readMore.addEventListener("click", () => {
    tableDom.classList.add("is-open");
    readMore.classList.add("is-hide");
  });
};

const setSplide = () => {
  document.querySelectorAll(".js-splide_products").forEach((element) => {
    const splide_products = new Splide(element, {
      autoplay: false,
      type: "slide",
      pagination: false,
      arrows: true,
      interval: 1000,
      speed: 300,
      fixedWidth: 255,
      perPage: 1,
      drag: true,
      start: 0,
      breakpoints: {
        1080: {
          autoWidth: true,
          gap: 0,
          arrows: false,
        },
      },
    });

    splide_products.mount();
  });
};

const cloneReviewRating = () => {
  const reviewRating = document.getElementsByClassName("star-ratings-css")[0];
  const reviewRatingText = document.getElementsByClassName(
    "mxpr-summary__count"
  )[0];
  const cloneReviewRating = reviewRating.cloneNode(true);
  const cloneReviewRatingText = reviewRatingText
    .cloneNode(true)
    .innerText.trim();
  const productReviewRating = document.getElementsByClassName(
    "product-review-rating-stars"
  )[0];
  const productReviewRatingText = document.getElementsByClassName(
    "product-review-rating-text"
  )[0];

  productReviewRating.appendChild(cloneReviewRating);
  productReviewRatingText.textContent = `(${cloneReviewRatingText})`;
};

const setLinkShareEvent = () => {
  const shareLink = document.querySelector("#link-share");

  if (!shareLink) return;

  shareLink.addEventListener("click", async () => {
    try {
      const data = {
        title: document.title,
        url: location.href,
      };
      await navigator.share(data);
    } catch (error) {
      console.error(error);
    }
  });
};

const setClickEvents = () => {
  setLinkShareEvent();
};

const setFaqEvent = () => {
  const questions = document.querySelectorAll(".product-specs-faq h2");

  if (!questions) return;

  questions.forEach((question, index) => {
    if (index === 0) {
      question.classList.add("active");
      question.nextElementSibling.classList.add("active");
    }
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      if (answer) {
        question.classList.toggle("active");
        answer.classList.toggle("active");
      }
    });
  });
};

const syncQuantityInputs = () => {
  const quantityInput = document.querySelector("[data-quantity-input]");
  const quantityInputSticky = document.querySelector(
    "[data-quantity-input-sticky]"
  );

  if (!quantityInput || !quantityInputSticky) return;

  quantityInput.addEventListener("change", (e) => {
    quantityInputSticky.value = e.target.value;
  });

  quantityInputSticky.addEventListener("change", (e) => {
    quantityInput.value = e.target.value;
  });
};

// コメントのもっと見る
const setProductComments = () => {
  const content = document.querySelector(".product-summary");
  if (!content) {
    return;
  }

  const button = document.querySelector(".product-summary__show-more");
  const h2Elements = content.querySelectorAll("h2");

  if (h2Elements.length >= 4) {
    const heightLimit = Array.from(h2Elements)
      .slice(0, 5)
      .reduce((height, h2) => {
        return (
          height +
          h2.offsetHeight +
          (h2.nextElementSibling ? h2.nextElementSibling.offsetHeight : 0)
        );
      }, 0);

    content.style.maxHeight = `${heightLimit}px`;
    content.style.overflow = "hidden";
    button.style.display = "block";

    button.addEventListener("click", function () {
      const isExpanded = content.style.maxHeight !== `${heightLimit}px`;
      button.style.display = "none";

      if (!isExpanded) {
        content.style.maxHeight = `${content.scrollHeight}px`;
      } else {
        content.style.maxHeight = `${heightLimit}px`;
      }
    });
  }
};

const initializePhotoSwipe = () => {
  const lightbox = new PhotoSwipeLightbox({
    gallery: "#gallery",
    children: "a",
    pswpModule: PhotoSwipe,
    padding: { top: 20, bottom: 20, left: 20, right: 20 },
  });

  lightbox.init();
};

const initialize = () => {
  cloneReviewRating();
  setReadmore();
  setSplide();
  setClickEvents();
  setFaqEvent();
  syncQuantityInputs();
  initializePhotoSwipe();
  setProductComments();
};

document.addEventListener("DOMContentLoaded", () => {
  initialize();
});
